export default [
  { to: 'nyheter', title: 'Nyheter' },
  { to: 'beredskapsjour', title: 'Beredskapsjour' },
  { to: 'rekommenderade_lakemedel', title: 'Rekommenderade Läkemedel' },
  { to: 'amnesomraden', title: 'Ämnesområden' },
  { to: 'utbildningar', title: 'Utbildningar' },
  { to: 'ovrigt', title: 'Övrigt' },
];
